// Use relative path since Apache proxy handles routing
// This will work whether you're on localhost or your VPS domain
export const API_BASE_URL = "/api";

export const uploadFile = async (file, modelProvider, modelName) => {
    const formData = new FormData();
    formData.append("file", file);

    const params = new URLSearchParams({
        model_provider: modelProvider,
        model_name: modelName
    });

    const response = await fetch(`${API_BASE_URL}/upload?${params.toString()}`, {
        method: "POST",
        body: formData,
    });

    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Upload failed");
    }
    return result;
};

export const saveRecord = async (payload) => {
    const response = await fetch(`${API_BASE_URL}/save`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Save failed");
    }
    return result;
};

export const getRecords = async () => {
    const response = await fetch(`${API_BASE_URL}/records`);
    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Fetch records failed");
    }
    return result.records;
};

export const extractTable = async (file, modelProvider, modelName) => {
    const formData = new FormData();
    formData.append("file", file);
    const params = new URLSearchParams({
        model_provider: modelProvider,
        model_name: modelName
    });

    const response = await fetch(`${API_BASE_URL}/extract-table?${params.toString()}`, {
        method: "POST",
        body: formData,
    });

    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Table extraction failed");
    }
    return result;
};

export const analyzeFraud = async (recordId, modelProvider) => {
    const response = await fetch(`${API_BASE_URL}/detect-fraud/${recordId}?model_provider=${modelProvider}`, {
        method: "POST",
    });

    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Fraud analysis failed");
    }
    return result;
};

export const getRecordById = async (recordId) => {
    const response = await fetch(`${API_BASE_URL}/records/${recordId}`);
    if (!response.ok) {
        throw new Error(`Failed to fetch record: ${response.status}`);
    }
    return response.json();
};

// Additional API functions for invoices/factures
export const uploadFacture = async (dossierId, file, modelProvider = "gemini") => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(
        `${API_BASE_URL}/dossier/${dossierId}/upload-facture?model_provider=${modelProvider}`,
        {
            method: "POST",
            body: formData,
        }
    );

    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Facture upload failed");
    }
    return result;
};

export const getDossierFactures = async (dossierId) => {
    const response = await fetch(`${API_BASE_URL}/dossier/${dossierId}/factures`);
    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Failed to fetch factures");
    }
    return result;
};

export const deleteFacture = async (factureId) => {
    const response = await fetch(`${API_BASE_URL}/facture/${factureId}`, {
        method: "DELETE",
    });

    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Delete facture failed");
    }
    return result;
};

export const getFactureDetails = async (factureId) => {
    const response = await fetch(`${API_BASE_URL}/facture/${factureId}`);
    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Failed to fetch facture details");
    }
    return result;
};

export const getDashboardStats = async () => {
    const response = await fetch(`${API_BASE_URL}/dashboard-stats`);
    const result = await response.json();
    if (!response.ok) {
        throw new Error(result.detail || "Failed to fetch dashboard stats");
    }
    return result;
};